/**
 * Normalize a base path to a leading-slash, non-trailing-slash form. Any value is stringified,
 * empty input becomes `/`.
 */
export function normalizeBasePath(value: unknown): string {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return '/';

  const withLeadingSlash = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  const collapsed = withLeadingSlash.replace(/\/{2,}/g, '/');
  return collapsed.length > 1 && collapsed.endsWith('/') ? collapsed.slice(0, -1) : collapsed;
}

/**
 * `decodeURIComponent` that returns the stringified input instead of throwing on malformed
 * sequences. With `trim`, the value is trimmed before decoding.
 */
export function safeDecodeURIComponent(value: unknown, { trim = false } = {}): string {
  const rawValue = trim ? String(value ?? '').trim() : String(value ?? '');
  try {
    return decodeURIComponent(rawValue);
  } catch {
    return rawValue;
  }
}
